import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import logo from "../images/catalyst/logo.png";
import LinkCard from "../components/catalyst/LinkCard";
import Countdown from "react-countdown";
import ReactGA from "react-ga";

const Catalyst = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  const logoRef = useRef(null);
  const titleRef = useRef(null);

  const spinLogo = (e) => {
    ReactGA.event({
      category: "CATALYST",
      action: "easter_egg",
      label: "easter_egg_l",
    });

    gsap.fromTo(
      "#catalyst-logo",
      {
        rotate: "0",
      },
      {
        rotate: "-360",
        duration: 2,
        ease: "expo.inOut",
      }
    );

    gsap.fromTo(
      "#catalyst-logo",
      1,
      {
        scale: 1,
      },
      {
        scale: 1.1,
        yoyo: true,
        repeat: 1,
        duration: 1,
        ease: "expo.in",
      },
      "<"
    );
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);

    gsap.set(".link-card", {
      autoAlpha: 0,
      scale: 0.6,
      y: 40,
    });
    gsap.set(".sc-title", {
      autoAlpha: 0,
      y: 60,
    });

    gsap.to(".sc-title", {
      y: 0,
      ease: "expo.out",
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      delay: 0.5,
    });

    gsap.to(".link-card", {
      y: 0,
      ease: "expo.inOut",
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      stagger: 0.1,
    });
  }, []);

  return (
    <div className="w-full min-h-screen text-white pb-8" style={styles.blackbg}>
      <div className="w-full flex flex-col justify-center items-center pt-10"></div>

      <div className="w-full max-w-md m-auto mt-8 mb-10 px-4 grid">
        <div className="text-4xl text-center sc-title">Day 2</div>

        <LinkCard
          title="🏠 Main Plenary"
          color="#f00"
          newTab={true}
          link="https://www.aiesec.lk/catalyst2021-day2"
        />

        <div className="text-xl text-center sc-title mt-8">
          Functional Sessions
        </div>

        <LinkCard
          title="🐘 iGV"
          color="#F85A40"
          newTab={true}
          link="https://zoom.us/j/94478676038?pwd=VXdDai9PY1AyYVNZbXJhQ1lqT3ZlZz09"
        />

        <LinkCard
          title="✈ oGV"
          color="#F48924"
          newTab={true}
          link="https://zoom.us/j/99069320313?pwd=d2JFdGhUTEVKRXMxRUxCY1E0OEVFUT09"
        />

        <LinkCard
          title="👨‍🏫 iGT"
          color="#FFC845"
          newTab={true}
          link="https://zoom.us/j/94374648958?pwd=eHVzbEFXRk5Fd3o0T2pJZXJtcjRBUT09"
        />

        <LinkCard
          title="🕴 oGT"
          color="#037Ef3"
          newTab={true}
          link="https://zoom.us/j/91996872382?pwd=bm1veGFPVFZUdHduSUhnMlpja2UzUT09"
        />

        <div className="text-xl text-center sc-title mt-8">Workshops</div>

        <LinkCard
          title="💪 Leadership Body"
          color="#0CB9C1"
          newTab={true}
          link="https://zoom.us/j/97918983976?pwd=WTZzbGtsanA2NzJ0M29vejNCUFFNZz09"
        />

        <LinkCard
          title="🤵 Members"
          color="#00C16E"
          newTab={true}
          link="https://zoom.us/j/91678509009?pwd=bU1ha0svV1VuTGVUU0xoYlhVemd5QT09"
        />
      </div>
    </div>
  );
};

export default Catalyst;
